import { useCallback, useEffect, useMemo, useState, useRef } from 'react';

export default function AbsoluteText(props) {
  
  const calculeCoords = useCallback((size, coord_x, coord_y) => {
    const scaleFactorY = (props.img.clientHeight - props.img.spacingVertical) / props.img.naturalHeight;
    const scaleFactorX = (props.img.clientWidth - props.img.spacingHorizontal) / props.img.naturalWidth;
    const mediaSize = Math.round(size / 2);
    return {
      coord_x: coord_x * scaleFactorX - mediaSize,
      coord_y: coord_y * scaleFactorY,
    }
  }, [props.img]);

  const textRef = useRef();
  const [size, setSize] = useState(props.size);

  useEffect(() => {
    if (props.size === undefined && textRef) {
      setSize(textRef.current.offsetWidth);
    }
  }, [props.text, textRef.current])

  const { coord_x, coord_y } = useMemo(() => calculeCoords(size, props.coord_x, props.coord_y), [props.img, size, props.coord_x, props.coord_y]);

  return (<>
    <div key={props.id}
      id={`absolute-text-${props.id}`}
      ref={textRef}
      style={{
        position: 'absolute',
        top: `${coord_y.toFixed(2)}px`,
        left: `${coord_x.toFixed(2)}px`,
      }}
    >
      {props.text}
    </div>
  </>);
}